import React, { Component } from "react";
import isAuthenticated from "../../services/auth";

import { Button, Icon, notification } from "antd";

import { Form, Input } from "@rocketseat/unform";

import api from "../../services/api";

import "./styles.css";

export default class Auth extends Component {
  /**
   * Autenticação do usuário
   */
  state = {
    loading: false
  };

  /** User authentication */
  handleSubmit = async (data, { resetForm }) => {
    this.setState({
      loading: true
    });

    await api
      .post("/auth/", data)
      .then(response => {
        localStorage.setItem("auth_token", response.data.token);
        localStorage.setItem("auth_username", response.data.username);
        localStorage.setItem("auth_userid", response.data.user_id);
        localStorage.setItem("auth_superuser", response.data.super_user);

        api.defaults.headers.common.Authorization = `Token ${response.data.token}`;
      })
      .catch(error => {
        if (error.response) {
          const statusCode = error.response.status;

          if (statusCode === 401) {
            notification.error({ message: "Usuário ou senha incorretos." });
            resetForm();
          } else
            notification.error({
              message: "Não foi possível realizar o login."
            });
        } else notification.warn({ message: "Sem resposta do servidor." });
      });

    this.setState({
      loading: false
    });
  };

  componentDidMount() {
    if (isAuthenticated()) {
      this.props.redirect.redirect("/dashboard");
    }
  }

  componentDidUpdate() {
    if (isAuthenticated()) {
      window.location.reload();
    }
  }

  render() {
    return (
      <div className="auth-container">
        <div className="auth-sub-container shadow">
          <div className="auth-sub-container__header">
            <div className="auth_logo">
              <div className="mt-2">
                <h2>HUB</h2>
                <small>COBRANÇAS</small>
              </div>
            </div>
          </div>
          <div className="auth-sub-container__fields">
            <Form onSubmit={this.handleSubmit}>
              <span className="ant-input-affix-wrapper">
                <span className="ant-input-prefix">
                  <Icon type="user" style={{ color: "rgba(0,0,0,.5)" }} />
                </span>
                <Input
                  type="text"
                  placeholder="Usuário"
                  required
                  name="username"
                  className="ant-input"
                />
              </span>
              <br />
              <br />
              <span className="ant-input-affix-wrapper">
                <span className="ant-input-prefix">
                  <Icon type="lock" style={{ color: "rgba(0,0,0,.5)" }} />
                </span>
                <Input
                  type="password"
                  placeholder="Senha"
                  required
                  name="password"
                  className="ant-input"
                />
              </span>
              <div className="form_button">
                <Button htmlType="submit" loading={this.state.loading}>
                  ENTRAR
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Auth/index.js